import { formatDistanceToNow, format, isToday } from 'date-fns';
import { ru } from 'date-fns/locale';
export const getDateTimeString = (date) => {
    return date ? format(date, 'yyyy-MM-dd HH:mm:ss') : '';
};
export const getRuDateTimeString = (date) => {
    return date ? format(date, 'dd.MM.yyyy HH:mm') : '';
};
export const getTimeAgo = (dateISO, addSuffix = true, includeSeconds = false) => {
    const targetDate = new Date(dateISO);
    return isToday(targetDate)
        ? formatDistanceToNow(targetDate, { addSuffix, includeSeconds, locale: ru })
        : getRuDateTimeString(targetDate);
};
//# sourceMappingURL=date.utils.js.map